import React, { useEffect } from "react";

import MessageTemplatesPage from "../../components/APanel/MessageTemplates/MessageTemplatesPage";

// Admin → Mesaje automate: textele trimise automat elevilor (chat, notificări, email).
export default function APMessageTemplates() {
   useEffect(() => {
      document.title = "Instruire Auto | Mesaje automate";
   }, []);

   return (
      <main className="main">
         <section className="page-wrapper">
            <MessageTemplatesPage />
         </section>
      </main>
   );
}
